import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { Link } from '../stories/Link';
import { YouTubeVideo } from './YouTubeVideo';

type OwnProps = {
  show: boolean;
  setShow: (_: boolean) => void;
  youtubeVideoId: string;
};

export const HelpPageVideoModal = (props: OwnProps) => {
  const __ = useTranslation().t;

  return (
    <Modal
      show={props.show}
      onHide={() => props.setShow(false)}
      keyboard={false}
      id="help-page-modal"
      centered
    >
      <Modal.Body>
        <div>
          <div className="embed-container">
            <YouTubeVideo videoId={props.youtubeVideoId} autoplayEnabled />
          </div>
          <Link
            onClick={() => props.setShow(false)}
            italic={false}
            variant="black-main"
            icon="arrow-left"
            className="pt-1 d-inline-block"
          >
            {__('return')}
          </Link>
        </div>
      </Modal.Body>
    </Modal>
  );
};
